import { Container, AlertTitle, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Page from 'components/Page';
import LockIcon from '@mui/icons-material/Lock';

// ----------------------------------------------------------------------
const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function PermissionGuard() {
  return (
    <RootStyle title="Permission Denied | Serviceplug">
      <Container>
        <Box sx={{ textAlign: 'center' }}>
          <LockIcon sx={{ mb: 5, mx: 'auto', fontSize: 160 }} color="error" />

          <Typography variant="h3" gutterBottom color="warn">
            Permission Denied
          </Typography>
          <AlertTitle>You do not have permission to access this page</AlertTitle>
        </Box>
      </Container>
    </RootStyle>
  );
}
